const PREFIX = "USER-PERFORMANCE";

export class GET_USER_PERFORMANCE {
  public static readonly type = `[${PREFIX} GET USER PERFORMANCE]`;
  constructor(public readonly payload) {}
}

export class GET_PAGE_ACCESS {
  public static readonly type = `[${PREFIX} GET PAGE ACCESS]`;
  constructor(public readonly payload) {}
}
